// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Keep default index CSS or customize
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Import Ant Design CSS (Use reset for better consistency)
import "antd/dist/reset.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
